import Eardrum from './core/Eardrum';
export default new Eardrum();
